import React, { Fragment } from "react";
import { Backdrop, CircularProgress, Container } from "@mui/material";
import ContactUs from "../../components/ContactUs";
import { ApiCallStatus } from "../../utils/constants";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";

const ContactUsPage = ({ genericDataLoaded, genericPageContent }) => {
  const allLoadingStates = [];

  const pageIsLoading =
    allLoadingStates.includes(ApiCallStatus.InProgress) ||
    genericDataLoaded === false;

  return (
    <Container maxWidth="lg">
      <Breadcrumbs />
      <ContactUs />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={pageIsLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
};
export default ContactUsPage;
